import { ConfigType } from '../../models/api.interface';
import { useQuery } from './useQuery';

export const usePostQuery = <BodyData, ResponseData>(
  // <BodyData> and <ResponseData> are "generic types" that are passed so that we can expect
  // to send/receive whatever data we want when we use this hook.
  query: string,
  config?: ConfigType,
) => {
  return useQuery<BodyData, ResponseData>('post', query, config);
};
